import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {Helmet} from "react-helmet";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {route} from "../../../routes";
import {
  ButtonSecondary,
  GelContentContainer,
  HeroBlock,
  Role,
  Controls,
  FormErrorSummary,
  Notices, FormWrap, InputLanguageSwitcher
} from "cw-styleguide-react";
import VenueCreateEditForm from "../components/VenueCreateEditForm";



import {
  ACTION_PUBLISH,
  ACTION_QA,
  ACTION_SAVE,
  ACTION_TRANSLATE,
  OPERATION_CREATE,
  ROLE_PROVIDER,
  ROLE_STAFF,
  STATUS_DRAFT
} from "../../../constants";
import withAssets from "../../../components/hoc/withAssets";

class VenuesCreateView extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.t('local:view.venues.create.title')}</title>
        </Helmet>

        <BreadcrumbsItem to={route('venuesManage') + '/' + route('venuesCreate')}>
          {this.props.t('view.venues.create.breadcrumb')}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.t('local:view.venues.create.title')}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t('local:view.venues.create.introduction')}</p>
        </HeroBlock>

        <GelContentContainer>

          <Notices messages={this.props.messages} />
          <FormErrorSummary errors={this.props.formErrors}  handleErrorClick={this.props.handleErrorClick} />

          <FormWrap noPadding={true} noBackground={true}>

            <Controls>
              <ButtonSecondary url={route('venuesManage') + this.props.query} title={this.props.t('local:view.venues.manage.controls.cancel')}>{this.props.t('local:view.venues.manage.controls.cancel')}</ButtonSecondary>
              <ButtonSecondary  onClick={() => {this.props.saveVenue(this.props.getSaveState(STATUS_DRAFT, ACTION_SAVE))}} title={this.props.t('local:view.venues.manage.controls.save')}>{this.props.t('local:view.venues.manage.controls.save')}</ButtonSecondary>
              <Role roles={[ROLE_PROVIDER]}>
                <ButtonSecondary  onClick={() => {this.props.saveVenue(this.props.getSaveState(STATUS_DRAFT, ACTION_QA))}} title={this.props.t('local:view.venues.manage.controls.sendToQa')}>{this.props.t('local:view.venues.manage.controls.sendToQa')}</ButtonSecondary>
              </Role>
              <Role roles={[ROLE_STAFF]}>
                <ButtonSecondary  onClick={() => {this.props.saveVenue(this.props.getSaveState(STATUS_DRAFT, ACTION_TRANSLATE))}} title={this.props.t('local:view.venues.manage.controls.sendForTranslation')}>{this.props.t('local:view.venues.manage.controls.sendForTranslation')}</ButtonSecondary>
                <ButtonSecondary   onClick={() => {this.props.saveVenue(this.props.getSaveState(STATUS_DRAFT, ACTION_PUBLISH))}} title={this.props.t('local:view.venues.manage.controls.publish')}>{this.props.t('local:view.venues.manage.controls.publish')}</ButtonSecondary>
              </Role>
            </Controls>

            <Controls>
              <InputLanguageSwitcher language={this.props.inputLanguage} onChange={this.props.handleSetInputLanguage}/>
            </Controls>

          </FormWrap>

          <VenueCreateEditForm {...this.props}  mode={OPERATION_CREATE} />
        </GelContentContainer>
      </Fragment>
    )
  }
}

export default withAssets(withTranslation('local')(VenuesCreateView));
